"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.summonFor = exports.AsUOpaque = exports.AsOpaque = void 0;
var core_1 = require("@morphic-ts/common/lib/core");
var interpreters_1 = require("@morphic-ts/eq-interpreters/lib/interpreters");
var interpreters_2 = require("@morphic-ts/io-ts-interpreters/lib/interpreters");
var interpreters_3 = require("@morphic-ts/show-interpreters/lib/interpreters");
var summoners_1 = require("@morphic-ts/summoners");
/**
 *  @since 0.0.1
 */
var AsOpaque = function () { return function (x) { return x; }; };
exports.AsOpaque = AsOpaque;
/**
 *  @since 0.0.1
 */
var AsUOpaque = function () { return function (x) { return x; }; };
exports.AsUOpaque = AsUOpaque;
/**
 *  @since 0.0.1
 */
var summonFor = function (env) {
    return summoners_1.makeSummoner(core_1.cacheUnaryFunction, function (program) {
        var _a = program(interpreters_2.modelIoTsNonStrictInterpreter())(env), create = _a.create, type = _a.type;
        return {
            build: function (a) { return a; },
            eq: program(interpreters_1.modelEqInterpreter())(env).eq,
            show: program(interpreters_3.modelShowInterpreter())(env).show,
            strictType: program(interpreters_2.modelIoTsStrictInterpreter())(env).type,
            type: type,
            create: create
        };
    });
};
exports.summonFor = summonFor;
